import "./styles/tokens.css";
import "./styles/base.css";
import { useMemo } from "react";
import axios from "axios";
import { BrowserRouter } from "react-router-dom";
import { ApiProvider } from "./app/ApiContext";
import { SettingsProvider } from "./data/settings";
import { AppRoutes } from "./app/routes";
import { API_BASE_URL } from "./app/config";

function App() {
	// Memoised so child pages see a stable instance and do not refetch on every App render
	const api = useMemo(() => axios.create({ baseURL: API_BASE_URL }), []);

	return (
		<ApiProvider api={api}>
			<SettingsProvider>
				<BrowserRouter>
					<AppRoutes />
				</BrowserRouter>
			</SettingsProvider>
		</ApiProvider>
	);
}

export default App;
